// TimeWeekSummaryDay.tsx

import styles from './TimeWeekSummaryDay.module.scss';

type TimeWeekSummaryDayProps = {
  weekDay: string;
  timeOff: number;
  sickLeave: number;
  work: number;
  holiday: number;
  isHoliday: Record<string, string> | undefined;
  overtime: number;
  total: number;
  notApplicable?: boolean; // New optional prop
};

function TimeWeekSummaryDay({
  weekDay,
  timeOff,
  sickLeave,
  work,
  holiday,
  isHoliday,
  overtime,
  total,
  notApplicable = false, // Default to false
}: TimeWeekSummaryDayProps) {
  return (
    <div className={styles.timeWeekSummaryDay}>
      <div className={styles.timeWeekSummaryDayRow}>
        <div className={styles.timeWeekSummaryDayRowLabel}>
          {weekDay}
          {isHoliday ? ' - ' + isHoliday.label : ''}
        </div>
        <div className={styles.timeWeekSummaryDayRowValue}>
          {total.toFixed(2)} {`time${total > 1 ? 'r' : ''}`}
        </div>
      </div>

      {notApplicable ? (
        <div className={styles.timeWeekSummaryDayRow}>
          <div className={styles.timeWeekSummaryDayRowLabel}>
            Ikke en arbejdsdag
          </div>
          <div className={styles.timeWeekSummaryDayRowValue}>–</div>
        </div>
      ) : (
        <>
          {timeOff > 0 && (
            <div className={styles.timeWeekSummaryDayRow}>
              <div className={styles.timeWeekSummaryDayRowLabel}>Fri</div>
              <div className={styles.timeWeekSummaryDayRowValue}>
                {timeOff.toFixed(2)} {`time${timeOff > 1 ? 'r' : ''}`}
              </div>
            </div>
          )}
          {sickLeave > 0 && (
            <div className={styles.timeWeekSummaryDayRow}>
              <div className={styles.timeWeekSummaryDayRowLabel}>Syg</div>
              <div className={styles.timeWeekSummaryDayRowValue}>
                {sickLeave.toFixed(2)} {`time${sickLeave > 1 ? 'r' : ''}`}
              </div>
            </div>
          )}
          {work > 0 && (
            <div className={styles.timeWeekSummaryDayRow}>
              <div className={styles.timeWeekSummaryDayRowLabel}>
                Arbejdstid
              </div>
              <div className={styles.timeWeekSummaryDayRowValue}>
                {work.toFixed(2)} {`time${work > 1 ? 'r' : ''}`}
              </div>
            </div>
          )}
          {holiday > 0 && (
            <div className={styles.timeWeekSummaryDayRow}>
              <div className={styles.timeWeekSummaryDayRowLabel}>Ferie</div>
              <div className={styles.timeWeekSummaryDayRowValue}>
                {holiday.toFixed(2)} {`time${holiday > 1 ? 'r' : ''}`}
              </div>
            </div>
          )}
          {overtime > 0 && (
            <div className={styles.timeWeekSummaryDayRow}>
              <div className={styles.timeWeekSummaryDayRowLabel}>
                Arbejde u.f. normtid
              </div>
              <div className={styles.timeWeekSummaryDayRowValue}>
                {overtime.toFixed(2)} {`time${overtime > 1 ? 'r' : ''}`}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default TimeWeekSummaryDay;
